import * as React from 'react';
import { useState } from 'react';
import { Page } from 'components/page/page';
import { Card } from 'components/card/card';
import { Input } from 'components/input/input';
import { Button, buttonType } from 'components/button/button';
import './deposit-utopia.scss';
import { message, Descriptions, Typography } from 'antd';
import { API } from 'apis';
import { CopyOutlined } from '@ant-design/icons';
import { postViaAuth, responseValidator } from 'apis/api';
import { digitSperator } from 'core/utils/decimalExtentions';

// Types
type VoucherCharge = {
    trackingCode: string;
    amount: number;
};

export const DepositUtopia: React.FC = () => {
    const [voucherCode, setVoucherCode] = useState<string>('');
    const [voucherInfo, setVoucherInfo] = useState<VoucherCharge>();
    const [loading, setLoading] = useState<boolean>(false);

    const depositUtopia = async () => {
        if (!voucherCode) return;
        setLoading(true);
        try {
            const response: any = await postViaAuth<VoucherCharge>(API.voucher.depositUtopiaByAdmin, {
                voucher: voucherCode,
            });
            if (responseValidator(response.status)) {
                message.success('شارژ با موفقیت انجام شد.');
                setVoucherInfo(response.value);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Page className="pmx-deposit-utopia" title="شارژ یوتوپیا">
            <Card className="voucher-charge" title="شارژ یوتوپیا">
                <div className="filter-row">
                    <div className="fields">
                        <Input
                            value={voucherCode}
                            placeholder="کد ووچر"
                            onChange={(e) => setVoucherCode(e.target.value)}
                            onPressEnter={depositUtopia}
                        />
                        <div className="buttons">
                            <Button
                                loading={loading}
                                disabled={loading}
                                text="شارژ"
                                type={buttonType.success}
                                onClick={depositUtopia}
                            />
                        </div>
                    </div>
                </div>
            </Card>

            {voucherInfo ? (
                <Card title="اطلاعات شارژ" className="voucher-info">
                    <section>
                        <Descriptions className="voucher-desc" colon={false} column={1}>
                            <Descriptions.Item label="کد پیگیری:">
                                {(() => {
                                    const value = voucherInfo?.trackingCode || '-';
                                    return (
                                        <Typography.Text
                                            className="en"
                                            ellipsis={{ tooltip: value }}
                                            copyable={
                                                voucherInfo?.trackingCode
                                                    ? {
                                                        text: voucherInfo.trackingCode,
                                                        icon: [<CopyOutlined />, <CopyOutlined />],
                                                    }
                                                    : false
                                            }
                                        >
                                            {value}
                                        </Typography.Text>
                                    );
                                })()}
                            </Descriptions.Item>

                            <Descriptions.Item label="مقدار:">
                                <Typography.Text
                                    className="en"
                                    ellipsis={{ tooltip: String(digitSperator(voucherInfo?.amount) || '-') }}
                                    copyable={
                                        typeof voucherInfo?.amount === 'number'
                                            ? {
                                                text: String(voucherInfo.amount),
                                                icon: [<CopyOutlined />, <CopyOutlined />],
                                            }
                                            : false
                                    }
                                >
                                    {digitSperator(voucherInfo?.amount) || '-'}
                                </Typography.Text>
                            </Descriptions.Item>
                        </Descriptions>
                    </section>
                </Card>
            ) : null}
        </Page>
    );
};
